import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import CommonDialog from "../CommonDialog";
import { DIALOG_FIELD_TYPES } from "../../common/Stores/constant/constant";
import {
  createBuilderUser,
  fetchBuilderUserJobConf,
} from "./shopDetail/service/service";
import { isFurigana, isPhoneNumber } from "utils/validator";
import isEmail from "validator/lib/isEmail";

class PrimaryUserDialog extends React.Component {
  state = {
    builders: {
      email: null,
      name: null,
      furigana:null,
      phone: null,
      job: null,
    },
    currentDateStatus: {},
    newFieldList: [],
  };

  defaultValues = {
    name: null,
    furigana: null,
    email: null,
    phone: null,
    job: null,
  };

  fieldList = [
    {
      name: "name",
      label: "ユーザー名",
      type: DIALOG_FIELD_TYPES.Text,
      isRequired: true
    },
    {
      name: "furigana",
      label: "ユーザー名(ふりがな)",
      type: DIALOG_FIELD_TYPES.Text,
      isRequired: true
    },
    {
      name: "email",
      label: "メールアドレス​",
      type: DIALOG_FIELD_TYPES.Text,
      isRequired: true
    },
    {
      name: "phone",
      label: "個人携帯",
      type: DIALOG_FIELD_TYPES.Text,
      isRequired: false
    },
  ];

  fieldListEdit = [
    ...this.fieldList,
  ];

  componentDidMount() {
    (async() => {
      const res = await fetchBuilderUserJobConf();
      const options = res.map((jobOption) => {
        return {
          uniqueCode: jobOption.id,
          name: jobOption.name,
        };
      });
      this.fieldList.push(
        {
          name: "job",
          label: "役割",
          type: DIALOG_FIELD_TYPES.DropDownBox,
          options,
          isRequired: true,
        },
      )
      this.setState({ newFieldList: this.fieldList });
    })()
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.builders !== nextProps.builder) {
      this.setState({
        builders: nextProps.builder
      });
    }
  }

  toggleDialogDelete = () => {
    this.props.toggleDialogDelete();
  };

  onSubmit = async (valuesForm) => {
    const builderId = this.props.match.params.id
    let isValidated = false;
    for (const key in valuesForm) {
      // NOTE: Validate null
      if (
        (key === 'email' || key === 'name' || key === 'furigana' || key === 'job') &&
        (valuesForm[key] === null)
      ) {
        console.log(`${key} is null!`);
        isValidated = true;
        return;
      }

      // NOTE: Validate furigana.
      if (key === 'furigana' && !isFurigana(valuesForm[key])) {
        console.log(`${key} is not FURIGANA!`);
        isValidated = true;
        return;
      }

      // NOTE: Validate email
      if (key === 'email' && !isEmail(valuesForm[key])) {
        console.log(`${key} is not EMAIL!`);
        isValidated = true;
        return;
      }

      // NOTE: Validate phone
      if (key === 'phone' && !!valuesForm[key] && !isPhoneNumber(valuesForm[key])) {
        console.log(`${key} is not PHONE_NUMBER!`);
        isValidated = true;
        return;
      }
    }
    if (!!isValidated) return;
    await createBuilderUser(builderId, valuesForm);
    this.props.onCloseDialog();
  };

  currentDate = (fieldName, date) => {
    if (date?.toString() === "Invalid Date") {
      this.setState({
        currentDateStatus: {
          ...this.state.currentDateStatus,
          [fieldName]: ""
        }
      });
    } else {
      const newDateStatus = { ...this.state.currentDateStatus };
      delete newDateStatus[fieldName];
      this.setState({
        currentDateStatus: newDateStatus
      });
    }
  };

  getMessage = (key, message) => {
    return message[key];
  };

  render() {
    const {
      isDialogShow,
      onCloseDialog,
      submitErrors,
    } = this.props;

    return (
      <>
        <CommonDialog
          title="プライマリーユーザー招待"
          isDialogShow={isDialogShow}
          initialValues={this.defaultValues}
          onSubmit={this.onSubmit}
          isEdit={false}
          onClose={onCloseDialog}
          fieldList={this.state.newFieldList}
          submitButtonTitle={"招待"}
          submitErrors={submitErrors}
          onDeleteClick={this.toggleDialogDelete}
          currentDate={this.currentDate}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  submitErrors: state.storesReducer.error,
  builder: state.builderReducer.builderDetailReducer.builder
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { createBuilderUser },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PrimaryUserDialog));
